<script setup lang="ts">
import type { CalculatedPrice } from '#shared/types/pricing'

defineProps<{
  isDiscounted: boolean
  isMetered: boolean
  price: CalculatedPrice
  originalPrice?: CalculatedPrice
}>()

const auth = useAuthorizeStore()

const key = computed(() => (isConsumer(auth.user) ? 'incVat' : 'exVat') satisfies keyof CalculatedPrice)
</script>

<template>
  <component
    :is="$attrs.is ?? 'span'"
    class="font-headline text-xl font-semibold"
    :class="$attrs.class"
  >
    <template v-if="price[key] > 0">
      <abbr v-if="isMetered && !auth.loggedIn">Max&nbsp;</abbr>{{ norwegianPrice(price[key]) }}&nbsp;per år<span v-if="isDiscounted || (isMetered && !auth.loggedIn)">*</span>
    </template>
    <span v-else-if="originalPrice" class="text-2xl">
      {{ norwegianPrice(originalPrice.exVat) }} neste skoleår<span class="align-top" aria-hidden="true">*</span>
    </span>
  </component>
  <span v-if="!isConsumer(auth.user)" class="text-base text-gray-40">
    {{ price[key] > 0 ? norwegianPrice(price.incVat) : norwegianPrice(originalPrice?.incVat) }}&nbsp;inkl.&nbsp;mva.
  </span>
</template>
